import React, { useRef,useEffect  } from 'react';
import { motion, useInView } from 'framer-motion';
import Topbar from '../../components/Bar/Topbar';
import Header from '../../components/Bar/Header';
import Banner from '../../components/Carousel/Banner';
import CallToAction from '../../components/Sections/CallToAction';
import FeaturesSection from '../../components/Sections/FeaturesSection';
import FactsSection from '../../components/Sections/FactsSection';
import ServiceSection from '../../components/Sections/ServiceSection';
import SubscribeSection from '../../components/Sections/SubscribeSection';
import Footer from '../../components/Footer/Footer';
import ServiceGrid from '../../components/Sections/ServiceGrid';
import MainContainer3 from '../../components/Carousel/MainContainer3';
import Hero from '../../components/Bar/Hero';

const AnimatedSection = ({ children, delay = 0.2 }) => {
    // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '0px 0px -100px 0px' });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 50 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.8, ease: 'easeOut', delay }}
    >
      {children}
    </motion.div>
  );
};

const Home = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 2, ease: 'easeOut' }}
    >
     
      <Header />
      <Banner />


      <AnimatedSection><CallToAction /></AnimatedSection>
      <AnimatedSection delay={0.3}><FeaturesSection /></AnimatedSection>
      <AnimatedSection delay={0.4}><MainContainer3 /></AnimatedSection>
  
      <AnimatedSection delay={0.6}><ServiceSection /></AnimatedSection>
      <AnimatedSection delay={0.7}><ServiceGrid /></AnimatedSection>
      <AnimatedSection delay={0.8}><SubscribeSection /></AnimatedSection>

      <Footer />
    </motion.div>
  );
};

export default Home;
